import React, { ReactChild } from 'react';

import * as styles from './styles.module.scss';

interface CardWrapProps {
  width: number,
  children: ReactChild,
  aspect?: number,
  className?: string
}

const CardWrap : React.FC<CardWrapProps> = ({ className = '', width, children, aspect = 1.6 }) => {
  const style = {
    '--card-wrap-width': `${ width }px`,
    '--card-wrap-height': `${ width * aspect }px`,
    '--card-wrap-scale': `${ width / 500 }`
  } as React.CSSProperties;

  return (
    <div className={`${ className } ${styles.cardwrap}`} style={style}>
      { children }
    </div>
  )
};

export default React.memo(CardWrap);
